import React from "react";
import { Redirect } from "react-router-dom";
import config from "../../config";

const withSignupEventCode = (path, signupEventCode) =>
  signupEventCode
    ? `${path}?signupEventCode=${encodeURIComponent(signupEventCode)}`
    : path;

const Outside = props => {
  return (
    <Redirect
      to={withSignupEventCode(
        config.SIGNUP.APP_PATH + "/autolocation",
        props.signupEventCode
      )}
    />
  );
};

export default Outside;
